import {
  GET_REPORT_DIMENSIONS,
  FETCH_REPORT_DIMENSION,
  ADD_REPORT_DIMENSION,
  UPDATE_REPORT_DIMENSION,
  DELETE_REPORT_DIMENSION,
  CLEAR_REPORT_DIMENSIONS,
  REPORT_DIMENSIONS_PAGE,
  CLEAR_ALL,
  REPORT_DIMENSIONS_PENDING, // Added pending action type
} from "../constants/actions";

const initialState = {
  report_dimensions: [],
  pending: false,
  pageNumber: 1,
  created: false,
  updated: false,
};

export default function reportDimensions(state = initialState, action) {
  switch (action.type) {
    case REPORT_DIMENSIONS_PENDING: // Added pending case
      return {
        ...state,
        pending: true,
      };
    case GET_REPORT_DIMENSIONS:
      return {
        ...state,
        report_dimensions: action.payload,
        pending: false,
      };
    case REPORT_DIMENSIONS_PAGE:
      return {
        ...state,
        pageNumber: action.payload,
      };
    case FETCH_REPORT_DIMENSION:
      return {
        ...state,
        [action.payload.id]: action.payload,
        pending: false,
      };
    case ADD_REPORT_DIMENSION:
      return {
        ...state,
        created: action.payload,
        pending: false,
      };
    case UPDATE_REPORT_DIMENSION:
      return {
        ...state,
        [action.payload.id]: action.payload,
        pending: false,
      };
    case DELETE_REPORT_DIMENSION:
      return {
        ...state,
        updated: Math.random(),
        pending: false,
      };
    case CLEAR_REPORT_DIMENSIONS:
      return {
        ...state,
        ...initialState,
      };
    case CLEAR_ALL:
      return initialState;
    default:
      return state;
  }
}